import { Component, OnDestroy, OnInit } from '@angular/core';
import { DzModalConfig, DzModalService } from '@blk/daisy/modules/modals';
import { TealiumAnalyticsEvent, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';
import { ApplicationPathConstants } from '@ddt-web/config';
import { AccountErrors } from '@ddt-web/shared-stores';
import { PortfolioHoldingsResolutionStateData, UrlRedirectService } from '@ddt-web/url';

@Component({
	templateUrl: './dirty-portfolio-dialog.component.html',
	styleUrls: ['./dirty-portfolio-dialog.component.scss']
})
export class DirtyPortfolioDialogComponent implements OnInit, OnDestroy {
	public dirtyPortfolioNames: string[];
	public holdingsResolutionState: PortfolioHoldingsResolutionStateData;
	private hasContinued: boolean = false;

	constructor(
		private config: DzModalConfig,
		private urlRedirectService: UrlRedirectService,
		private dzModalService: DzModalService,
		private tealiumAnalyticsService: TealiumAnalyticsService
	) { }

	public ngOnInit(): void {
		this.holdingsResolutionState = {
			previousState: this.config.contentData.previousState,
			portfolioUpdateSkipList: this.config.contentData.portfolioUpdateSkipList,
			isRefreshFlow: this.config.contentData.isRefreshFlow
		};

		const assetDetailsResponses = this.config.contentData.assetDetailsResponses;
		this.dirtyPortfolioNames = [...this.config.contentData.accountErrorMap]
			.filter(([accountId, portfolioErrors]: [string, AccountErrors]) => !!portfolioErrors.containsUnresolvedSecurities)
			.map(([accountId, portfolioErrors]: [string, AccountErrors]) => assetDetailsResponses.find(response => response.accountId === accountId).accountName);
	}

	public onContinue(): void {
		this.hasContinued = true;
		this.dzModalService.closeAll();
		this.urlRedirectService.redirectToExternalPortfolioHoldingsResolutionPage(this.holdingsResolutionState);
	}

	public onCancel(): void {
		this.dzModalService.closeAll();
		if (!this.holdingsResolutionState.isRefreshFlow) {
			if (this.holdingsResolutionState.previousState?.routeOrigin?.includes('analysis/')) {
				this.holdingsResolutionState.previousState.routeOrigin = ApplicationPathConstants.OVERVIEW_TAB_PATH;
			}
			this.urlRedirectService.redirectToImportPartnerPortfoliosWithState(this.holdingsResolutionState.previousState, true);
		}
	}

	public ngOnDestroy(): void {
		if (!this.hasContinued) {
			this.dzModalService.closeAll();
			if (this.holdingsResolutionState.isRefreshFlow) {
				this.holdingsResolutionState.previousState.routeOrigin = ApplicationPathConstants.NEW_ANALYSIS_PAGE_PATH;
				this.urlRedirectService.redirectToImportPartnerPortfoliosWithState(this.holdingsResolutionState.previousState, false);
			}
			this.tealiumAnalyticsService.trackEventTealium(new TealiumAnalyticsEvent(
				TealiumConstants.IMPORT_PARTNER_PORTFOLIO_EVENTS.WORKFLOW_ABANDONMENT,
				{ portfolioCount: this.dirtyPortfolioNames.length }
			));
		}
	}
}
